import { z } from 'zod'

import { CONTRACT_TYPES } from '@/pages/instruments/new-instrument/constants/contract-types'
import { baseInstrumentSchema } from '@/pages/instruments/new-instrument/schemas/shared/base.schema'
import { underlyingsSchema } from '@/pages/instruments/new-instrument/schemas/shared/underlyings.schema'

export const baseVanillaSchema = baseInstrumentSchema
  .extend({
    structure_name: z.string().min(1),
    currency_id: z.number().int().positive(),
    counterparty_id: z.number().int().positive(),
    notional: z.number(),
    asset_identifier: z.enum(CONTRACT_TYPES),
    comment: z.string().optional(),
    isin: z.string().nullable(),
    fund_id: z.number().int().positive(),
    initial_observation_date: z.iso.date(),
    maturity_date: z.iso.date(),
    settlement_cycle: z.number().int().positive(),
    underlyings: underlyingsSchema,
    bucket_id: z.number().int().positive().nullable(),
  })
  .superRefine((values, ctx) => {
    const isin = values.isin

    if (!!isin && isin?.length !== 12) {
      ctx.addIssue({
        code: 'custom',
        path: ['isin'],
        message: 'ISIN must be 12 characters long.',
      })
    }
  })

export type BaseVanillaSchemaType = z.infer<typeof baseVanillaSchema>
